import React, { useEffect, useState } from 'react';
import Highcharts from 'highcharts';
import HighchartsMore from 'highcharts/highcharts-more';
import Exporting from 'highcharts/modules/exporting';
import Accessibility from 'highcharts/modules/accessibility';
import HighchartsReact from 'highcharts-react-official';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';

HighchartsMore(Highcharts);
Exporting(Highcharts);
Accessibility(Highcharts);

// #####################
// ### chart options ###
// #####################
const default_options = {
  title: {
    text: 'Drought Severity and Coverage Index for Vermont'
  },
  subtitle: {
    text: 'Click and drag on chart to zoom.'
  },
  yAxis: {
    title: {
        text: "DSCI"
    },
  },
  xAxis: {
    type: "datetime",
    gridLineWidth: 1,
    min: Date.UTC(2000, 0, 4),
    dateTimeLabelFormats: {
      year: '%b-%Y',
      month: '%e-%b-%Y',
      day: '%e-%b-%Y',
      hour: '%e-%b-%Y'
    },
  },
  chart: {
    zoomType: "x",
  },
  legend: {
    enabled: false,
  },
  credits: {
    enabled: false,
  },
  tooltip: {
    headerFormat: '',
    pointFormat: '{point.x:%B %e, %Y}: <b>{point.y}</b>',
  },
  series: [],    //added later
};

const DsciGraph = (props) => { 
  const [ showDialog, setShowDialog ] = useState(false);
  const [ chart, setChart ] = useState(null);
  const [ options, ] = useState(default_options);

  // ### fill_graph ###
  const fill_graph = (results_data) => {
    const items = [];
    results_data.forEach(item => {
      const dateObject = new Date(item.mapDate);
      const timestamp = dateObject.getTime()
      items.push([timestamp, item.dsci])
    })
    const new_series = {
      type: "area",
      lineWidth: 0,
      color: "goldenrod",
      marker: {
        enabled: false,
      },
      data: items,
    };
    chart.addSeries(new_series)
  };

  // ### get data ###
  const fill_dsci_graph = () => {
    const dataFileName = "https://nedews.nrcc.cornell.edu/vt/data/dsci_vt.json";
    fetch(dataFileName)
      .then(res => res.json())
      .then(results => {
          fill_graph(results);
      })
      .catch(err => {
          console.error(err);
      });
}
  // access to chart
  const afterChartCreated = (chart) => {
    setChart(chart);
    chart.showLoading();
  };

  const handleOpenDialog = () => { setShowDialog(true); };
  const handleCloseDialog = () => { setShowDialog(false); };

  useEffect(() => {
    if (chart && chart.hasOwnProperty('options')) {
      fill_dsci_graph();
      chart.hideLoading();
    }
    // eslint-disable-next-line
  }, [chart]);

  return (
    <>
      <HighchartsReact
          highcharts={Highcharts}
          options={options}
          callback={afterChartCreated}
      />

      <div style={{paddingLeft:'1em'}}>
        <Button 
          variant="outlined"
          size="small"
          sx={{position:'absolute',right:"1em"}}
          onClick={handleOpenDialog}
        >
          About this product
        </Button>
      </div>
      
      <Dialog
        open={showDialog}
        onClose={handleCloseDialog}
        scroll='paper'
      >
        <DialogTitle>Drought Severity and Coverage Index</DialogTitle>
        <DialogContent>
          <p>The Drought Severity and Coverage Index is an experimental method for converting drought levels from the U.S. Drought Monitor map to a single value for an area. Possible values of the DSCI are from 0 to 500. Zero means that none of the area is abnormally dry or in drought, and 500 means that all of the area is in D4, exceptional drought. For more information visit the <a href="https://droughtmonitor.unl.edu/About/AbouttheData/DSCI.aspx" target="_blank" rel="noreferrer">USDM DSCI About Page</a></p>.
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog}>Close</Button>
        </DialogActions>
      </Dialog>
    </>
  )
}

export default DsciGraph;
